import React from "react";
import { Create } from "react-admin";
import { EditActions } from "../../common/form/FormActions";
import { NotificationSubscriptionForm } from "./NotificationSubscriptionForm";
import { useNotification } from "../../../common/hooks/useNotification";
import { useFieldPermissions } from "../../../common/hooks/useFieldPermissions";
import { FieldPermissionsContext } from "../../common/field-permissions/FieldPermissionsContext";
import { protectedEntities } from "../../../common/auth/permissions";

interface INotificationSubscriptionCreateProps {}

export const NotificationSubscriptionCreate = (
  props: INotificationSubscriptionCreateProps
) => {
  const notify = useNotification(props, "createSuccess");
  const fieldPermissions = useFieldPermissions(
    protectedEntities.NotificationSubscription,
    (x) => x.create
  );
  return (
    <FieldPermissionsContext.Provider value={fieldPermissions}>
      <Create
        {...props}
        actions={<EditActions />}
        onSuccess={notify}
        title="resources.admin-notifications.title.create">
        <NotificationSubscriptionForm />
      </Create>
    </FieldPermissionsContext.Provider>
  );
};
